<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--R/O 기초정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001179') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--딜러점-->
							<th class="col-1">{{ getMessage_('QWCC000959') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="dlrCpnyCd" class="inputWithIcon" readonly></el-input>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="dlrCpnyNm" :placeholder="getMessage_('QWCC001068')" readonly />
							</td>

							<!--수리지역-->
							<th class="col-1">{{ getMessage_('QWCC001049') }}</th>
							<td class="col-1">
								<el-input v-model="rprRegn" maxlength="55" readonly />
							</td>

							<!-- 발생지역 -->
							<th class="col-1">{{ getMessage_('QWCC001050') }}</th>
							<td class="col-1">
								<el-select v-model="occuRegn" disabled>
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in occuRegnListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<!--지역세부-->
							<th class="col-1">{{ getMessage_('QWCC001051') }}</th>
							<td class="col-1">
								<el-input v-model="dtlRegn" maxlength="55" readonly />
							</td>
						</tr>

						<tr>
							<!--원인부품-->
							<th class="col-1">* {{ getMessage_('QWCC001028') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="causPartNo" class="inputWithIcon" readonly></el-input>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="causPartNm" :placeholder="getMessage_('QWCC000957')" readonly />
							</td>

							<!--정비유형-->
							<th class="col-1">* {{ getMessage_('QWCC001180') }}</th>
							<td class="col-1">
								<el-select v-model="ceqType" disabled>
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in ceqTypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<!--진단일자-->
							<th class="col-1">{{ getMessage_('QWCC001054') }}</th>
							<td class="col-1">
								<el-date-picker v-model="dgnDd" type="date" readonly />
							</td>

							<!--사용기간-->
							<th class="col-1">{{ getMessage_('QWCC001053') }}</th>
							<td class="col-1">
								<el-input v-model="usePrd" readonly />
							</td>
						</tr>
						<tr>
							<!--원인코드-->
							<th class="col-1">* {{ getMessage_('QWCC001029') }}</th>

							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input v-model="causCd" class="inputWithIcon" maxlength="20" readonly></el-input>
									</div>
								</el-col>
								<!--
								<el-select v-model="causCd" @change="changeCausCd" :disabled="pwaApcnPopUp.readOnlyAuth">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in causCdListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
								-->
							</td>
							<!--원인코드명-->
							<td class="col-2" colspan="2"><el-input v-model="causNm" :placeholder="getMessage_('QWCC001308')" readOnly /></td>

							<!--ctype-->
							<th class="col-1">* {{ getMessage_('QWCC001056') }}</th>
							<td class="col-1">
								<el-select v-model="ctype" disabled>
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in ctypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<th class="col-1">DTC</th>
							<td class="col-1">
								<el-input v-model="dtc1" maxlength="20" readonly></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc2" maxlength="20" readonly></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc3" maxlength="20" readonly></el-input>
							</td>
						</tr>
						<tr>
							<!--현상코드-->
							<th class="col-1">* {{ getMessage_('QWCC001055') }}</th>
							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input v-model="phmnCd" class="inputWithIcon" readonly></el-input>
									</div>
								</el-col>
							</td>
							<td class="col-1" colspan="2">
								<el-input v-model="phmnNm" :placeholder="getMessage_('QWCC001070')" readonly />
							</td>

							<!--주행거리-->
							<th class="col-1">* {{ getMessage_('QWCC000972') }}</th>
							<td class="col-1">
								<el-input v-model="milg" maxlength="30" readonly />
							</td>

							<!--정비시작일-->
							<th class="col-1">{{ getMessage_('QWCC001183') }}</th>
							<td>
								<el-date-picker v-model="ceqStrtDd" type="date" readonly />
							</td>
							<!--정비완료일-->
							<th class="col-1">{{ getMessage_('QWCC001184') }}</th>
							<td>
								<el-date-picker v-model="ceqEndDd" type="date" readonly />
							</td>
						</tr>

						<tr>
							<!--자재비-->
							<th class="col-1">* {{ getMessage_('QWCC001101') }}</th>
							<td>
								<el-input v-model="mtrlCst" maxlength="10" readonly></el-input>
							</td>
							<!--공임비-->
							<th class="col-1">* {{ getMessage_('QWCC001102') }}</th>
							<td>
								<el-input v-model="wags" maxlength="10" readonly></el-input>
							</td>
							<!--부대비-->
							<th class="col-1">* {{ getMessage_('QWCC001103') }}</th>
							<td>
								<el-input v-model="incdCst" maxlength="10" readonly></el-input>
							</td>

							<!--총금액-->
							<th class="col-1">{{ getMessage_('QWCC001104') }}</th>
							<td class="col-1">
								<el-input v-model="totPartCst" readonly></el-input>
							</td>

							<th class="col-1" />
							<td class="col-1" />
						</tr>

						<tr>
							<!--특이사항-->
							<th class="col-1">{{ getMessage_('QWCC000053') }}</th>
							<td colspan="9">
								<el-input v-model="prtlSbc" maxlength="330" readonly></el-input>
							</td>
						</tr>
						<tr>
							<!--첨부파일-->
							<th class="col-1">{{ getMessage_('QWCC000925') }}</th>
							<td colspan="9">
								<file-upload-list
									ref="fileUploadComp"
									id="fileList"
									:propFileList="resultFileList_"
									@MultiFile="multiFile"
									:isEditable="isFiledDisabled()"
									maxQuantity="10"
									width="100%"
									height="100px"
									@onDownload="onDownloadFile"
								></file-upload-list>
							</td>
						</tr>
					</tbody>
					<!--  -->
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { FileUploadList },
	data() {
		return {
			ceqType: '', //정비유형
			dlrCpnyCd: '', //딜러점코드
			dlrCpnyNm: '', //딜러점명
			rprRegn: '', //수리지역
			occuRegn: '', //발생지역
			dtlRegn: '', //지역세부
			causPartNo: '', //원인부품
			causPartNm: '', //원인부품명
			usePrd: '', //사용기간
			milg: '', //주행거리
			dgnDd: '', //진단일자
			causCd: '', //원인코드
			causNm: '', //원인코드명
			phmnCd: '', //현상코드
			phmnNm: '', //현상코드명
			ctype: '', //ctypeCd
			dtc1: '', //dtc1
			dtc2: '', //dtc2
			dtc3: '', //dtc3
			prtlSbc: '', //특이사항

			roFileId: '', //RO전용 파일ID
			ceqStrtDd: '', //정비시작일
			ceqEndDd: '', //정비종료일
			mtrlCst: '', //자재비
			wags: '', //공임비
			incdCst: '', //부대비
			totPartCst: '', //총금액
			pwaFileId: '', //pwaFileId
			//납품업체 검색 저장하는 객체
			delCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cpnyScn: '90'
			},
			commCd: {
				commCdType: 'PHMN_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			partNoInput: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		isFiledDisabled() {
			return false;
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		multiFile(files, delFiles) {
			//console.log('부모창', files, delFiles);
			this.setState_({ key: 'fileList', value: files });

			//console.log('전달확인', this.fileList);
		},
		setProcessInfo() {
			//스토어에서 값을 가져와서 셋팅한다.
			//this.ceqType = this.clamMstPopUp.ceqType; //정비유형
			this.dlrCpnyCd = this.clamMstPopUp.dlrCpnyCd; //딜러점코드
			this.dlrCpnyNm = this.clamMstPopUp.dlrCpnyNm; //딜러점명
			this.rprRegn = this.clamMstPopUp.rprRegn; //수리지역
			this.occuRegn = this.clamMstPopUp.occuRegn; //발생지역
			this.dtlRegn = this.clamMstPopUp.dtlRegn; //지역세부
			this.causPartNo = this.clamMstPopUp.causPartNo; //원인부품
			this.causPartNm = this.clamMstPopUp.causPartNm; //원인부품명
			this.usePrd = this.clamMstPopUp.usePrd; //사용기간
			this.milg = this.clamMstPopUp.milg; //주행거리
			this.dgnDd = this.clamMstPopUp.dgnDd; //진단일자
			this.causCd = this.clamMstPopUp.causCd; //원인코드
			this.causNm = this.clamMstPopUp.causNm; //원인코드명
			this.phmnCd = this.clamMstPopUp.phmnCd; //현상코드
			this.phmnNm = this.clamMstPopUp.phmnNm; //현상코드명
			this.ctype = this.clamMstPopUp.ctype; //ctypeCd
			this.dtc1 = this.clamMstPopUp.dtc1; //dtc1
			this.dtc2 = this.clamMstPopUp.dtc2; //dtc2
			this.dtc3 = this.clamMstPopUp.dtc3; //dtc3
			this.prtlSbc = this.clamMstPopUp.prtlSbc; //특이사항
			this.pwaFileId = this.clamMstPopUp.pwaFileId; //PWA에서 오는 파일ID
			this.roFileId = this.clamMstPopUp.roFileId; //ro전용 파일ID

			//this.ceqStrtDd = this.clamMstPopUp.ceqStrtDd; //정비시작일
			//this.ceqEndDd = this.clamMstPopUp.ceqEndDd; //정비종료일
			this.mtrlCst = this.clamMstPopUp.mtrlCst; //자재비
			//this.wags = this.clamMstPopUp.wags; //공임비
			//this.incdCst = this.clamMstPopUp.incdCst; //부대비
			this.totPartCst = this.clamMstPopUp.totPartCst; //총금액
			//받아온 파일 리스트조회
			this.$refs.fileUploadComp.reloadFileList(this.fileList);
		}
	},
	async created() {
		try {
			//let place1 = this.$sf_formatString(this.getMessage_('QWCC001064'), [this.getMessage_('QWCC000959')]);

			this.$sf_toggleLoading(true);

			await this.getCommCodes_({ key: 'ceqTypeList', codeType: 'CEQ_TYPE' }) //정비유형
				.then(() => this.getCommCodes_({ key: 'ctypeList', codeType: 'CTYPE' })) //CTYPE
				.then(() => this.getCommCodes_({ key: 'causCdListPop', codeType: 'CAUS_CD' })) //원인코드
				.then(() => this.getCommCodes_({ key: 'occuRegnListPop', codeType: 'OCCU_REGN' })); //

			//스토어에서 값을 가져와서 셋팅한다.

			this.ceqType = this.clamMstPopUp.ceqType; //정비유형
			this.dlrCpnyCd = this.clamMstPopUp.dlrCpnyCd; //딜러점코드
			this.dlrCpnyNm = this.clamMstPopUp.dlrCpnyNm; //딜러점명

			this.rprRegn = this.clamMstPopUp.rprRegn; //수리지역
			this.occuRegn = this.clamMstPopUp.occuRegn; //발생지역

			this.dtlRegn = this.clamMstPopUp.dtlRegn; //지역세부
			this.causPartNo = this.clamMstPopUp.causPartNo; //원인부품
			this.causPartNm = this.clamMstPopUp.causPartNm; //원인부품명

			this.usePrd = this.clamMstPopUp.usePrd; //사용기간
			this.milg = this.clamMstPopUp.milg; //주행거리

			this.dgnDd = this.clamMstPopUp.dgnDd; //진단일자
			this.causCd = this.clamMstPopUp.causCd; //원인코드
			this.causNm = this.clamMstPopUp.causNm; //원인코드명

			this.phmnCd = this.clamMstPopUp.phmnCd; //현상코드
			this.phmnNm = this.clamMstPopUp.phmnNm; //현상코드명

			this.ctype = this.clamMstPopUp.ctype; //ctypeCd
			this.dtc1 = this.clamMstPopUp.dtc1; //dtc1

			this.dtc2 = this.clamMstPopUp.dtc2; //dtc2
			this.dtc3 = this.clamMstPopUp.dtc3; //dtc3
			this.prtlSbc = this.clamMstPopUp.prtlSbc; //특이사항
			this.pwaFileId = this.clamMstPopUp.pwaFileId; //pwa파일Id
			this.roFileId = this.clamMstPopUp.roFileId; //ro전용 파일ID

			this.ceqStrtDd = this.clamMstPopUp.ceqStrtDd; //정비시작일
			this.ceqEndDd = this.clamMstPopUp.ceqEndDd; //정비종료일
			this.mtrlCst = this.clamMstPopUp.mtrlCst; //자재비
			this.wags = this.clamMstPopUp.wags; //공임비
			this.incdCst = this.clamMstPopUp.incdCst; //부대비
			this.totPartCst = this.clamMstPopUp.totPartCst; //총금액

			this.$sf_toggleLoading(false);
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateClamSave_({ key: 'aplCausPartNo', value: convertNvl(this.causPartNo, '') }); // 원인부품번호
			}
		}
	}
};
</script>
